import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  hashHistory
} from 'react-router';
import { Toast } from 'antd-mobile/lib';
import Util from '../../util';
import { getStorage } from '../../common';
import { clearSmrzOne } from "../../action/investmentAction.js";
import {goPubQuestionnaires,judgeQuestionnaires} from '../../getPay';

let ua=navigator.userAgent.toLowerCase()

class MakePlanResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
     modalList: false,
     modalFundListArr: [],
     modalFundTitle: "",
     modalXai: false
    };
  }
  componentWillMount() {
   
  }
  componentWillUnmount(){

  }
  componentDidMount() {
    
  }
  goBackFun = () => {
    hashHistory.goBack();
  }
  showModal = (title, data) => {
    this.setState({
      modalFundListArr: data,
      modalFundTitle: title
    }, () => {
      this.setState({
        modalList: true
      });
    });
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "hidden";
    obj.addEventListener("touchmove", this.touchMove, false);
  }
  closeModal = () => {
    this.setState({
      modalList: false
    });
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "auto";
    obj.removeEventListener("touchmove", this.touchMove, false);
  }
  investNotDetil = (data) => {
    if(ua.indexOf("amcfmapp")>-1) {
      // window.location.href = "http://mtest.chinaamc.com/huaXiaCaiFu/fullMarketTouguDetailPage/index.html?fundCode=" + data.superFundCode;//测试
      if(data.superFundCode == 'SF1022'){
        window.location.href = "https://m.chinaamc.com/huaXiaCaiFu/touguDetailPage/index.html?fundCode=" + data.superFundCode;//生产
      }else{
         window.location.href = "https://m.chinaamc.com/huaXiaCaiFu/fullMarketTouguDetailPage/index.html?fundCode=" + data.superFundCode;//生产
      } 
      return;
    }
    let pathName = "/SuperFundDetail";
    if(data.fundType === "1") {
      pathName = '/TargetProfitDetail';
    }else {
      pathName = '/SuperFundDetail';
    }

    hashHistory.push({
      pathname:pathName,
        state:{superFundName:data.fundName,superFundCode:data.superFundCode},
        query: {superFundName:data.fundName,superFundCode:data.superFundCode}
    })
  }
  showModalXiaoai = () => {
    this.setState({
      modalXai: true
    });
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "hidden";
    obj.addEventListener("touchmove", this.touchMove, false);
  }
  closeModalXai = () => {
    this.setState({
      modalXai: false
    });
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "auto";
    obj.removeEventListener("touchmove", this.touchMove, false);
  }
  goToMakePlan = async () => {
    if(this.props.location.state && this.props.location.state.rootPath == "MakePlanDetail") {
      this.goBackFun();
      return;
    }
    Toast.loading();
    let flagDigital=await getStorage('loginState');
    let _currentUserInfo = await getStorage('currentUserInfo');
    console.log(flagDigital, _currentUserInfo)
    if(flagDigital == '1'){
      //实名认证
      this.props.dispatch(clearSmrzOne())
      Toast.hide()
      hashHistory.push({
          pathname:'/CertificationUpload',
          state:{
            route:window.history.length,
            phoneNo:_currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
            callback:ua.indexOf("amcfmapp") > -1 ? ()=>{this.goToMakePlan()} : null
          }
      })
      return;
    }else if(flagDigital=='3'){
      Toast.hide()
      //同步开户
      hashHistory.push({
          pathname:'/BindingMobile',
          state:{route:window.history.length,callback:()=>{this.goToMakePlan()}}
      })
      return;
    }else if(flagDigital=='0'){
      Toast.hide()
      hashHistory.push({
          pathname: ua.indexOf("amcfmapp") > -1 ? '/LoginHxjj' : '/Login',
          state:{route:window.history.length,callback:ua.indexOf("amcfmapp") > -1 ? ()=>{this.goToMakePlan()} : null}
      })
      return;
    }else {
      Toast.hide();
      let didQuestionnairs = false;
      try{
        didQuestionnairs = await judgeQuestionnaires();
      }catch(err){
        return;
      }
      if(!didQuestionnairs) {
        goPubQuestionnaires(hashHistory, window.history.length, ()=>{
          this.goToMakePlan();
        });
        return;
      }
      let currentUserInfo= await getStorage('currentUserInfo');
      console.log(currentUserInfo);
      if(currentUserInfo && currentUserInfo.userMsg) {
        hashHistory.replace({
          pathname:'/MakePlanDetail',
          state: {
            certNo: currentUserInfo.userMsg.certType === "0" && currentUserInfo.userMsg.certNo ? currentUserInfo.userMsg.certNo : ""
          }
        });
      }
    }
  }
  render() {
    const arrList = this.props.location.state && this.props.location.state.fundListArr ? this.props.location.state.fundListArr : [];
    const arrListSec = [1, 2, 3, 4, 5];
    return (
      <div style={{display: "-webkit-flex", WebkitFlex:1, backgroundColor: "#fff", WebkitFlexDirection: "column", WebkitAlignItems: "center"}}>
        <div style={{backgroundImage: `url(${require("../../imgs/FinancialPlanning_bg.png")})`, backgroundSize: "cover", width: window.winWidth, height: window.winWidth / (1125 / 1113),paddingRight:20,paddingLeft:20 }}>
          {
            ua.indexOf("amcfmapp")>-1 ?
            null
            :
            <div style={{paddingTop: 56}}>
              <img onClick={this.goBackFun} src={require("../../imgs/eq_leftArrow1.png")} style={{width: 24, height: 24}} />
            </div>
          }
          <div style={{paddingTop: 18, WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "space-between", display: "-webkit-flex"}}>
            <p style={{fontSize: 24, color: "#fff", fontWeight: 500}}>华夏查理智投</p>
            <div style={{WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex"}}>
              <p style={{fontSize: 16, color: "#fff", fontWeight: 500}}>懂投资·更懂你</p>
              <img onClick={this.showModalXiaoai} src={require("../../imgs/icon_gth.png")} style={{width: 18, height: 18, marginLeft: 5}} />
            </div>
          </div>
        </div>
        <div style={{marginTop: ua.indexOf("amcfmapp")>-1 ? -309 : -225, paddingBottom: 20, width: window.winWidth, display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center"}}>
          { 
            this.props.location.state && this.props.location.state.tabListArr && this.props.location.state.tabListArr.length > 0 ?
            <div style={{paddingBottom: 10, width: window.winWidth - 40}}>
              {
                this.props.location.state.lookFlag == "部分" ?
                <p style={{fontSize: 13, color: "#fff", fontWeight: 500, lineHeight: "17px"}}>基于您的需求和对风险提示的确认，{this.props.location.state.tabListArr.join("、")}暂未匹配出投顾组合。<span onClick={this.goToMakePlan} style={{fontSize: 13, color: "#fff", fontWeight: 500, borderBottom: "solid"}}>重新规划</span></p>
                :
                <p style={{fontSize: 13, color: "#fff", fontWeight: 500, lineHeight: "17px"}}>{this.props.location.state.tabListArr.join("、")}暂未匹配出投顾组合。</p>
              }
            </div>
            :
            null
          }
          {
            arrList.map((data, index) => {
              if(data.superFundProductViewList && data.superFundProductViewList.length > 0) {
                return (
                  <ListView key={index} _showModal={(fir, sec) => {this.showModal(fir, sec)}} _investNotDetil={(res) => this.investNotDetil(res)} datas={data} indexs={index} />
                )
              }
            })
          }
        </div>
        <div style={{width: window.winWidth, WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingTop: 20, display: "-webkit-flex", backgroundColor: "#F8F8F8"}}>
          <div onClick={this.goToMakePlan} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", width: 122, height: 32, borderRadius: 4}}>
            <p style={{fontSize: 14, color: "#fff"}}>重新规划</p>
          </div>
        </div>
        <div style={{width: window.winWidth, backgroundColor: "#F8F8F8", paddingTop: 20, paddingBottom: 57, paddingLeft: 20, paddingRight: 20}}>
          <p style={{fontSize: 12, color: "#999", lineHeight: "17px"}}>{ua.indexOf("amcfmapp")>-1 ? '成立以来年化涨跌幅' : '成立以来年化收益'}等历史业绩仅作为参考，不预示组合未来表现。华夏财富不承诺组合收益，也不做保本承诺。基金投资组合策略的风险特征与单只基金产品的风险特征存在差异；投资者自主选择投顾组合，承担市场波动带来的损失；为其他客户创造的收益并不构成业绩表现的保证。</p>
        </div>
        {
          this.state.modalList ?
          <div onClick={this.closeModal} style={{position: "fixed", width: window.winWidth, top: 0, left: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.6)"}}></div>
          :
          null
        }
        {
          this.state.modalList ?
          <div style={{backgroundColor: "#fff", position: "fixed", bottom: 0, height: 558, borderTopLeftRadius: 8, borderTopRightRadius: 8, width: window.winWidth, overflowY: "auto", zIndex: 10}}>
            <img onClick={this.closeModal} src={require("../../imgs/jiantou_icon_sec.png")} style={{width: 14, height: 14, right: 20, top: 20, position: "absolute"}} />
            <div style={{paddingTop: 20}}>
              <p style={{fontSize: 18, color: "#333", fontWeight: 500, width: window.winWidth, textAlign: "center"}}>{this.state.modalFundTitle}</p>
            </div>
            {
              this.state.modalFundListArr.map((data, index) => {
                let colorSyl = "#F92C3D";
                if(data.fullOneYear) {
                  if(Util.returnEmpty(data.rate, "%") == "--%") {
                    colorSyl = "#333";
                  }else {
                    if(data.rate < 0) {
                      colorSyl = "rgba(54, 169, 99, 1)";
                    }else {
                      colorSyl = "#F92C3D";
                    }
                  }
                }else {
                  colorSyl = "#333";
                }
                return (
                  <div key={index} onClick={() => {this.investNotDetil(data)}} style={{width: window.winWidth, paddingLeft: 20, paddingRight: 20, paddingTop: 20}}>
                    <div>
                      <p style={{fontSize: 14, color: "#333"}}>{data.fundName}</p>
                    </div>
                    <div style={{marginTop: 15, display: "-webkit-flex", WebkitFlexDirection: "row", }}>
                      <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column"}}>
                        <p style={{fontSize: 18, color: colorSyl, fontWeight: 400, lineHeight: '20px'}}>{data.fullOneYear ? Util.returnEmpty(data.rate, "%") : "--%"}</p>
                        <p style={{fontSize: 11, color: "#666", marginTop: 5}}>{ua.indexOf("amcfmapp")>-1 ? '成立以来年化涨跌幅' : data.rateTypeName}</p>
                      </div>
                      <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column"}}>
                        <p style={{fontSize: 18, color: "#333", fontWeight: 400, lineHeight: '20px'}}>{data.holdTime}</p>
                        <p style={{fontSize: 11, color: "#666", marginTop: 5}}>{data.hold}</p>
                      </div>
                    </div>
                    <div style={{marginTop: 10, backgroundColor: "#F5F5F5", paddingTop: 8, paddingBottom: 8, paddingLeft: 10, paddingRight: 10, borderRadius: 2}}>
                      <p style={{fontSize: 11, color: "#666"}}>特点：{data.feature}</p>
                    </div>
                    {
                      index === this.state.modalFundListArr.length - 1 ?
                      <div style={{marginTop: 20}}></div>
                      :
                      <div style={{marginTop: 20, backgroundColor: "#EFF0F4", height: 1, width: window.winWidth - 40}}></div>
                    }
                  </div>
                )
              })
            }
          </div>
          :
          null
        }
        {
          this.state.modalXai ? 
          <div style={{width: window.winWidth, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, zIndex: 99999999, display: "-webkit-flex"}}>
            <div style={{WebkitFlexDirection: "column", width: 300, backgroundColor: "#fff", borderRadius: 20, WebkitAlignItems: "center",  display: "-webkit-flex"}}>
              <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitFlexDirection: "column"}}>
                <span style={{fontSize: 16, marginTop: 20, lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20,fontWeight:"500"}}>{"华夏查理智投依托于华夏财富多年的投顾服务经验，基于您在不同人生阶段的财富目标，通过智能化的算法模型为您匹配定制化财富管理方案，一站式满足您的资产保值、财富成长、品质养老、子女教育等场景需求。"}</span>
                <span style={{fontSize: 16,  lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20,fontWeight:"500"}}>{"我们希望通过专业化、场景化的基金投顾服务，帮助您降低筛选基金的门槛，并通过全程暖心陪伴服务，帮助您坚定地长期持有，将优选基金的业绩转化为您的实际回报，让您在投资过程中更省心、更安心。"}</span>
                <div onClick={this.closeModalXai} style={{ width:"100%", height:"40px", textAlign:"center", lineHeight:"40px",borderTopColor:"#ebeef0",borderTopWidth:"1px",borderTopStyle:"solid",marginTop:"15px"}}>
                  <div style={{WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex", height: "100%"}}>
                    <span style={{fontSize:17,color:'#666666'}}>知道了</span>
                  </div>
                </div> 
              </div>
            </div>           
          </div> 
          : 
          null
        }
      </div>
    );
  }
}

class ListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
     
    };
    this.imgList = [{
      id: "zcbz",
      img: require("../../imgs/icon_baozhi_grey.png")
    },{
      id: "cfcz",
      img: require("../../imgs/icon_chengzheng_gray.png")
    },{
      id: "pzyl",
      img: require("../../imgs/icon_yanglao.png")
    },{
      id: "znjy",
      img: require("../../imgs/icon_jiaoyu.png")
    }];
  }
  componentWillMount() {
   
  }
  componentWillUnmount(){

  }
  componentDidMount() {
    
  }
  showHideFun = (title, data) => {
    this.props._showModal(title, data);
  }
  returnImg = (id) => {
    for(let i = 0; i < this.imgList.length; i++) {
      if(id == this.imgList[i].id) {
        return (
          <img src={this.imgList[i].img} style={{width: 64, height: 64, right: 0, top: 0, position: "absolute"}} />
        )
      }
    }
  }
  render() {
    let colorSyl = "#F92C3D";
    if(this.props.datas.superFundProductViewList[0].fullOneYear) {
      if(Util.returnEmpty(this.props.datas.superFundProductViewList[0].rate, "%") == "--%") {
        colorSyl = "#333";
      }else {
        if(this.props.datas.superFundProductViewList[0].rate < 0) {
          colorSyl = "rgba(54, 169, 99, 1)";
        }else {
          colorSyl = "#F92C3D";
        }
      }
    }else {
      colorSyl = "#333";
    }
    return (
      <div style={{position: "relative", backgroundColor: "#fff", borderRadius: 4, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", paddingTop: 15, paddingBottom: this.props.datas.superFundProductViewList.length > 1 ? 10 : 15, paddingLeft: 15, paddingRight: 15, width: window.winWidth - 40, marginTop: this.props.indexs === 0 ? 0 : 10}}>
        <div onClick={() => {this.props._investNotDetil(this.props.datas.superFundProductViewList[0])}}>
          {
            this.returnImg(this.props.datas.sceneId)
          }
          <div>
            <p style={{fontSize: 16, color: "#2C3245", fontWeight: 500}}>{this.props.datas.sceneName}</p>
          </div>
          <div style={{paddingTop: 20}}>
            <p style={{fontSize: 14, color: "#333"}}>{this.props.datas.superFundProductViewList[0].fundName}</p>
          </div>
          <div style={{marginTop: 15, display: "-webkit-flex", WebkitFlexDirection: "row", }}>
            <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column"}}>
              <p style={{fontSize: 18, color: colorSyl, fontWeight: 400, lineHeight: '20px'}}>{this.props.datas.superFundProductViewList[0].fullOneYear ? Util.returnEmpty(this.props.datas.superFundProductViewList[0].rate, "%") : "--%"}</p>
              <p style={{fontSize: 11, color: "#666", marginTop: 5}}>{ua.indexOf("amcfmapp")>-1 ? '成立以来年化涨跌幅' : this.props.datas.superFundProductViewList[0].rateTypeName}</p>
            </div>
            <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column"}}>
              <p style={{fontSize: 18, color: "#333", fontWeight: 400, lineHeight: '20px'}}>{this.props.datas.superFundProductViewList[0].holdTime}</p>
              <p style={{fontSize: 11, color: "#666", marginTop: 5}}>{this.props.datas.superFundProductViewList[0].hold}</p>
            </div>
          </div>
          <div style={{marginTop: 10, backgroundColor: "#F5F5F5", paddingTop: 8, paddingBottom: 8, paddingLeft: 10, paddingRight: 10, borderRadius: 2}}>
            <p style={{fontSize: 11, color: "#666"}}>特点：{this.props.datas.superFundProductViewList[0].feature}</p>
          </div>
        </div>
        {
          this.props.datas.superFundProductViewList.length > 1 ?
          <div onClick={() => {this.showHideFun(this.props.datas.sceneName, this.props.datas.superFundProductViewList)}} style={{marginTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center"}}>
            <img src={require("../../imgs/jiantou_icon_sec.png")} style={{width: 14, height: 14}} />
          </div>
          :
          null
        }
      </div>
    )
  }
}


function mapStateToProps(state, ownProps) {
  return {

  }
}

export default connect(mapStateToProps)(MakePlanResult);


// WEBPACK FOOTER //
// ./src/components/fundDetail/MakePlanResult.js